import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import { DemandAdjustmentTargets } from "../../types/demand-factor.type";
import { TargetNames, buildTargetChipLabels } from "./targetSummary";

interface TargetChipsProps {
  targets: DemandAdjustmentTargets;
  names: TargetNames;
}

/** One chip per level the row narrows; a row that narrows nothing reaches every store. */
export default function TargetChips({ targets, names }: TargetChipsProps) {
  const chips = buildTargetChipLabels(targets, names);

  if (chips.length === 0) {
    return <Chip size="small" variant="outlined" label="ทั้งหมด" />;
  }

  return (
    <Stack direction="row" flexWrap="wrap" gap={0.5}>
      {chips.map((chip) => (
        <Chip key={chip.level} size="small" label={chip.label} title={chip.fullText} />
      ))}
    </Stack>
  );
}
